// extracted by mini-css-extract-plugin
module.exports = {"SwitchCourseStaff":"SwitchCourseStaff_SwitchCourseStaff__gjfjA"};